// src/stateManagers/roleAccess/access.ts

// Section-level rule, keyed by the FIRST path segment.
// 'public' = everyone, 'admin' = admin/superadmin only, otherwise a backend module key.
export const ACCESS: Record<string, string> = {
  '': 'public',                 // dashboard

  students: 'students',
  'students-pdf': 'students',
  'hall-tickets': 'students',
  teachers: 'teachers',
  noticeboard: 'noticeboard',
  events: 'events',
  'student-issues': 'issues',
  'bulk-password-reset': 'reset_users_password',
  exams: 'exams_calendar',
  visitors: 'visitors',
  expenses: 'expenses',
  fees: 'fees_management',
  timetable: 'timetable',

  staff: 'staff',
  'payroll-management': 'payroll_management',
  credentials: 'credentials',
  settings: 'settings',
  subjects: 'subjects',
  letterheads: 'letterheads',
  'letterhead-templates': 'letterhead_templates',
};

// Sub-section overrides, keyed by the FULL path.
// A path listed here uses its own module instead of the section rule above.
// To split another page, add its path here + a module in the backend.
export const SUB_ACCESS: Record<string, string> = {
  '/students':                   'students',
  '/students/bulk-photos':       'bulk_profile_photos',
  '/staff':                      'staff',
  '/staff/staff-attendance':     'staff_attendance',
  '/timetable/assigned-teachers': 'assigned_teachers',
};

// Rule for any path: exact sub-path override first, then the section rule, else admin-only.
export const ruleOf = (path: string): string =>
  SUB_ACCESS[path] ?? ACCESS[path.split('/')[1] ?? ''] ?? 'admin';